import { CheckoutFormView } from '@/components/checkform';

const CheckoutView = () => {
  return <CheckoutFormView />;
};

export default CheckoutView;
